<template>
  <button
    class="flex justify-center items-center px-10 sm:px-16 md:px-20 py-4"
    :disabled="disabled || isLoading"
    :title="text"
    :aria-label="text"
    :aria-describedby="`${id}-button-text`"
    :id="id"
  >
    <div v-if="isLoading" class="spinner"></div>
    <span :id="`${id}-button-text`" v-else>{{ $t(text) }}</span>
  </button>
</template>

<script>

export default {
  name: 'button-component',
  props: {
    id: {
      type: String,
      required: false,
      default: ''
    },
    text: {
      type: String,
      required: true,
      default: 'Click me!'
    },
    action: {
      type: [Array, Object],
      default: () => {
        return {}
      },
    },
    disabled: {
      type: Boolean,
      default: false
    },
    requires: {
      type: Array,
      required: false,
      default: () => {
        return []
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
@reference "../assets/style.css";

.primaryButton {
  @apply bg-primary text-secondary border border-primary transition-colors duration-200;
}

.primaryButton:disabled {
  @apply bg-primary-disabled cursor-not-allowed;
}

.primaryButton:hover:not(:disabled) {
  @apply bg-primary-hover;
}

.secondaryButton {
  @apply bg-secondary text-primary border border-primary transition-colors duration-200;
}

.secondaryButton:hover:not(:disabled) {
  @apply bg-primary-light;
}

.campaignBtn {
  @apply bg-gray-900 text-white font-bold transition-colors duration-200;
}

.campaignBtn:hover:not(:disabled) {
  @apply bg-gray-800;
}

.spinner {
  @apply w-6 h-6 border-4 border-gray-300 border-t-primary rounded-full animate-spin;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
